<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('JUDUL_TESIS')" :class="{'form-group': true, 'has-error': errors.has('judul')}">
        <label class="col-md-3"><span class="required-label">*</span>Judul Tesis</label>
        <div class="col-md-6">
          <input
            type="text"
            name="judul"
            placeholder="Judul Tesis"
            class="form-control"
            maxlength="255"
            v-model="model.judul"
            v-validate="isExist('JUDUL_TESIS') ? 'required' : ''"
          >
          <span v-show="errors.has('judul')" class="error-label">Isi Judul Tesis</span>
        </div>
      </div>
      <div v-show="isExist('FILE_TESIS')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>File Tesis</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointProposal"
            :headers="header"
            name="file_tesis"
            :data="dataUpload"
            :on-error="handleProposalError"
            :on-success="handleTesisSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.file_tesis"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf dan tidak boleh lebih dari 1 MB</strong></div>
          </el-upload>
          <div v-if="tesisUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="tesisUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('REKOMENDASI_TESIS')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Rekomendasi Tesis</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointRekomendasi"
            :headers="header"
            name="rekomendasi"
            :data="dataUpload"
            :on-error="handleRekomendasiError"
            :on-success="handleRekomendasiSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.rekomendasi_tesis"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            <a href="https://servdev2.admisi.uin-suka.ac.id/storage/docs-admin/2019.pdf" target="_blank">Download Format Surat Rekomendasi</a>
            </div>
          </el-upload>
          <div v-if="rekomendasiUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="rekomendasiUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      tesisUrl: null,
      rekomendasiUrl: null,
      model: {
        judul: null
      },
      savedModel: null,
      file: {
        file_tesis: [],
        rekomendasi_tesis: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  computed: {
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointProposal () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/proposal_tesis/tesis'
      } else {
        return 'test'
      }
    },
    docEndPointRekomendasi () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/proposal_tesis/rekomendasi'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(24).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let tesisUploaded = this.file.file_tesis.length > 0
              let rekomendasiUploaded = this.file.rekomendasi_tesis.length > 0
              !tesisUploaded && this.isExist('FILE_TESIS') ? reject({message: 'belum ada file tesis'}) : false
              !rekomendasiUploaded && this.isExist('REKOMENDASI_TESIS') ? reject({message: 'belum ada file rekomendasi tesis'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 24)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.getFileTesis()
        this.getFileRekomendasi()
        this.init = true
      }
    },
    handleProposalError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.file_tesis = [{name: 'tesis_' + this.nomorPendaftar + '.pdf'}]
        this.tesisUrl = 'Test'
      }
    },
    handleRekomendasiError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.rekomendasi_tesis = [{name: 'rekomendasi_tesis_' + this.nomorPendaftar + '.pdf'}]
        this.rekomendasiUrl = 'Test'
      }
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    handleTesisSuccess (res, file) {
      this.getFileTesis()
      alert('upload sukses')
    },
    handleRekomendasiSuccess (res, file) {
      this.getFileRekomendasi()
      alert('upload sukses')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getData () {
      this.loading = true
      api.get('/v1/proposal_tesis/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.model = data
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    getFileTesis () {
      api.get('/v2/proposal_tesis/tesis/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.file_tesis = [{name: 'tesis_' + this.nomorPendaftar + '.pdf'}]
            this.tesisUrl = responseData.url
          }
        })
    },
    getFileRekomendasi () {
      api.get('/v2/proposal_tesis/rekomendasi/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.rekomendasi_tesis = [{name: 'rekomendasi_tesis_' + this.nomorPendaftar + '.pdf'}]
            this.rekomendasiUrl = responseData.url
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/proposal_tesis', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataProposalTesis.vue